import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';

import { FaceIdResolverResolver } from './resolvers/face-id/face-id-resolver.resolver';

export const routes: Routes = [
  {
    path: 'trips',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-trips/trips.module').then((m) => m.TripsModule),
  },
  {
    path: 'safety-events',
    loadChildren: () => import('@app-incidents/incidents.module').then((m) => m.IncidentsModule),
  },
  {
    path: 'configurations',
    loadChildren: () => import('@app-asset-config/asset-configuration.module').then((m) => m.AssetConfigurationModule),
  },
  {
    path: 'notification-setting',
    loadChildren: () => import('@app-notification-setting/notification-setting.module').then((m) => m.NotificationSettingModule),
  },
  {
    path: 'drivers',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-driver-management/driver-management.module').then((m) => m.DriverManagementModule),
  },
  {
    path: 'live-view',
    loadChildren: () => import('@app-live-view/live-view.module').then((m) => m.LiveViewModule),
  },
  {
    path: 'coaching',
    loadChildren: () => import('@app-coaching/coaching.module').then((m) => m.CoachingModule),
  },
  {
    path: 'challenges',
    loadChildren: () => import('@app-challenged/challenged.module').then((m) => m.ChallengedModule),
  },
  {
    path: 'video-requests',
    loadChildren: () => import('@app-dvr/dvr.module').then((m) => m.DvrModule),
  },
  {
    path: 'user-management',
    loadChildren: () => import('@app-user-management/user-management.module').then((m) => m.UserManagementModule),
  },
  {
    path: 'reports',
    loadChildren: () => import('@app-reports/reports.module').then((m) => m.ReportsModule),
  },
  {
    path: 'assets',
    loadChildren: () => import('@app-assets/assets.module').then((m) => m.AssetsModule),
  },
  {
    path: 'diagnostics',
    loadChildren: () => import('@app-diagnostics/diagnostics.module').then((m) => m.DiagnosticsModule),
  },
  {
    path: 'trip-details',
    resolve: {
      faceIdEnabled: FaceIdResolverResolver,
    },
    loadChildren: () => import('@app-trip-details/trip-details.module').then((m) => m.TripDetailsModule),
  },
  {
    path: 'request-video',
    loadChildren: () => import('@app-request-video/request-video.module').then((m) => m.RequestVideoModule),
  },
  {
    path: 'notifications-page',
    loadChildren: () => import('@app-app-notifications/notifications-page.module').then((m) => m.NotificationsPageModule),
  },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      preloadingStrategy: PreloadAllModules,
      scrollPositionRestoration: 'enabled',
      relativeLinkResolution: 'legacy',
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
